import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import assetUrl from 'mk/common/assetUrl';
import React from 'react';

interface OwnProps {
    icon: string | IconLookup;
    className?: string;
}

const Icon: React.StatelessComponent<OwnProps> = ({ icon, className }) => {
    if (typeof icon === 'object') {
        if ((icon as IconLookup).prefix) {
            return (
                <FontAwesomeIcon
                    icon={icon as IconLookup}
                    size="lg"
                    className={className}
                />
            );
        } else {
            return null;
        }
    }

    let height;
    let width;
    switch (icon) {
        case 'action-file-delete-gray':
            height = 24;
            break;
        case 'fb':
            height = 20;
            width = 8;
            break;
    }

    // default icon is 16x16px
    height = height || 16;
    // if width is not specified we asume square icon
    width = width || height;

    const imgUrl = `${assetUrl}img/icons/bazaar/${icon}@2x.png`;

    return (
        // tslint:disable-next-line:jsx-ban-elements
        <img
            className={cx('icon', className)}
            src={imgUrl}
            height={`${height}px`}
            width={`${width}px`}
        />
    );
};

export default Icon;
